export default __webpack_public_path__ + "static/media/startlater@3x.8d65f1ab.jpg";